import React, { useState, useEffect } from "react";
import "./ImageCarousel.scss";
import { useHistory } from "react-router";
import arrow from "../../assets/icons/arrow-green.svg"
import valentines from "../../assets/images/valentines.png"
const ImageCarousel = ({ content }) => {

    const [currentIndex, setCurrentIndex] = useState(0);
    const history = useHistory()


    const goToNext = () => {
        setCurrentIndex((prev) => (prev === content.length - 1 ? 0 : prev + 1));
    };

    const goToIndex = (index) => {
        setCurrentIndex(index);
    };

    useEffect(() => {
        if (content.length > 1) {
            const timer = setInterval(() => {
                goToNext();
            }, 5000);

            return () => clearInterval(timer);
        }
    }, [currentIndex]);
    return (
        <div className="DosanChutney-carousel">
            <div
                className="DosanChutney-carousel-track"
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
                {content.map((contnt, i) => (
                    <div className={"DosanChutney-carousel-slide"} key={i}>
                        <img src={window.screen.width < 900 ? contnt.mobUrl : contnt.webUrl} alt={`Slide ${i}`} />
                        <div className="carousel-caption-container">
                            <div className="carpousel-sub-text">
                                {contnt.text}
                            </div>
                            <div className="carpousel-btnCont">

                                {contnt.buttonText && contnt.buttonText !== "" && <div className="carousel-btn"
                                    onClick={async () => {
                                        if (contnt.linkUrl?.includes("https://")) {
                                            if (contnt.linkUrl && contnt.linkUrl !== "") {
                                                window.open(contnt?.href, '_blank')
                                            }
                                            else {

                                            }
                                        } else {
                                            if (contnt.linkUrl !== "") {
                                                history.push(contnt.linkUrl)
                                            }
                                        }
                                    }}>
                                    {contnt.buttonText}
                                    <img alt="" src={arrow}
                                        className="carousel-secondaryBtn-ic" /></div>}
                                {contnt.secondaryButtonText && contnt.secondaryButtonText !== "" && <div className="carousel-secondaryBtn"
                                    onClick={async () => {
                                        history.push(contnt.secondaryButtonLinkUrl)
                                        if (contnt.secondaryButtonLinkUrl?.includes("https://")) {
                                            if (contnt.secondaryButtonLinkUrl && contnt.secondaryButtonLinkUrl !== "") {
                                                window.open(contnt.secondaryButtonLinkUrl, '_blank')
                                            }
                                            else {

                                            }
                                        } else {
                                            if (contnt.linkUrl !== "") {
                                                history.push(contnt.secondaryButtonLinkUrl)
                                            }
                                        }
                                    }}>
                                    {contnt.secondaryButtonText}
                                    <img alt="" src={arrow}
                                        className="carousel-secondaryBtn-ic" /></div>}
                            </div>
                        </div>
                        <img src={valentines} alt="" className="valenitines-banner " />
                    </div>
                ))}
            </div>

            {content.length > 1 && <div className="DosanChutney-carousel-dots">
                {content.map((_, i) => (
                    <div
                        key={i}
                        onClick={() => goToIndex(i)}
                        className={`dot-cs ${i === currentIndex ? "active" : ""}`}
                    />
                ))}
            </div>}
        </div>
    );
};

export default ImageCarousel;
